import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { getAlgoEditConfigLegs } from '../../../../stores/algo-edit-config/getters';
import { configLegDataUpdate } from '../../../../stores/algo-edit-config/actions';
import useAlgoRunning from '../../../../hooks/useAlgoRunning';
import useAlgoLoading from '../../../../hooks/useAlgoLoading';
import FlatSelectControlled from '../../../../components/Basic/FlatSelectControlled';
import {
  EXPIRY_CURRENT_MONTH,
  EXPIRY_CURRENT_WEEK,
  EXPIRY_NEXT_MONTH,
  EXPIRY_NEXT_WEEK,
} from '@quantiply/common/constants';
import useContract from './hooks/useContract';

const useStyles = makeStyles(() => ({
  root: {
    marginTop: 0,
    '& .MuiFormControl-fullWidth': {
      minWidth: 124,
      maxWidth: 124,
    },

    '& .MuiAutocomplete-hasPopupIcon .MuiAutocomplete-inputRoot': {
      paddingRight: 15,
    },
  },
  SelectOption: {
    fontSize: '0.95rem',
  },
}));

export const optionsSelectOptions = [
  {
    value: EXPIRY_CURRENT_WEEK,
    label: 'Weekly',
  },
  {
    value: EXPIRY_NEXT_WEEK,
    label: 'Next Weekly',
  },
  {
    value: EXPIRY_CURRENT_MONTH,
    label: 'Monthly',
  },
  {
    value: EXPIRY_NEXT_MONTH,
    label: 'Next Monthly',
  },
];

export const futuresSelectOptions = [
  {
    value: EXPIRY_CURRENT_MONTH,
    label: 'Monthly',
  },
];

function useOptions(id) {
  const base = useSelector((state) => {
    const { base = 'BANKNIFTY' } =
      getAlgoEditConfigLegs(state).find((d) => d.id === id) || {};

    return base;
  });
  const contract = useContract(base);

  const optionsSelectOptionsFiltered = optionsSelectOptions.filter((item) =>
    contract.includes(item.value)
  );

  const futuresSelectOptionsFiltered = futuresSelectOptions.filter((item) =>
    contract.includes(item.value)
  );

  const side = useSelector((state) => {
    const { side } =
      getAlgoEditConfigLegs(state).find((d) => d.id === id) || {};

    return side;
  });

  if (side) {
    return optionsSelectOptionsFiltered;
  }

  return futuresSelectOptionsFiltered;
}

function useSelectedOption(id) {
  const expiryTag = useSelector((state) => {
    const { expiryTag } =
      getAlgoEditConfigLegs(state).find((d) => d.id === id) || {};

    return expiryTag;
  });

  const side = useSelector((state) => {
    const { side } =
      getAlgoEditConfigLegs(state).find((d) => d.id === id) || {};

    return side;
  });

  if (!expiryTag) {
    if (side) {
      return optionsSelectOptions[0].value;
    } else {
      return futuresSelectOptions[0].value;
    }
  }

  return expiryTag;
}

function Contracts({ id }) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const algoRunning = useAlgoRunning();
  const loading = useAlgoLoading();
  const options = useOptions(id);
  const expiryTag = useSelectedOption(id);
  const onChange = (value) => {
    dispatch(configLegDataUpdate(id, 'expiryTag', value));
  };

  return (
    <FlatSelectControlled
      className={classes.root}
      disableClearable
      options={options}
      value={expiryTag}
      disabled={algoRunning || loading}
      onChange={onChange}
      placeholder="Contracts"
      renderOption={(option) => (
        <div className={classes.SelectOption}>{option.label}</div>
      )}
    />
  );
}

export default Contracts;
